import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { authClient } from '@/shared/lib/auth-client';
import { sessionExpiredStore } from '@/shared/lib/session-expired-store';

export const Route = createFileRoute('/_guest')({
  beforeLoad: async () => {
    sessionExpiredStore.reset();
    const { data: session } = await authClient.getSession();
    if (session) {
      throw redirect({ to: '/' });
    }
  },
  component: Outlet,
});
